import { UserRole } from 'network-graphql/src/graphql/types/graphql';
import { AuthUser } from '../auth/auth-client';

export function hasRequiredRole(requiredRoles: UserRole[], authUser: AuthUser | null) {
  // Admin and Super Admin have access to everything
  if (['ADMIN', 'SUPER_ADMIN'].some((role) => authUser?.role.includes(role))) {
    return true;
  }

  return false;
}

export function convertRoleConfigToUserRoles(roleConfig: { admin?: boolean; superAdmin?: boolean }) {
  const userRoles: UserRole[] = [];

  if (roleConfig.admin) userRoles.push(UserRole.Admin);
  if (roleConfig.superAdmin) userRoles.push(UserRole.SuperAdmin);

  return userRoles;
}
